import sessionStorage from '@avalara/bat-apps-shared/helpers/sessionStorage';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, useLocation, withRouter } from 'react-router-dom';
import ThankYou from '../../components/buy-flow/thank-you';
import TierSelector from '../../components/buy-flow/tier-selector';
import CybersourcePaymentPage from '../../components/cybersource-payment';
import PageNotFound from '../../components/page-not-found';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { checkIsAuthenticated } from '../../lib/helpers';
import { blockPageFromIndexing, getConnectors, getMarketingDataFromUrl } from '../../lib/side-effects';
import { selectConnector } from '../../lib/side-effects/connectors';
import { getSystemErrorMessaging } from '../../lib/side-effects/error';
import { selectState } from '../../selectors';
import { setTrialExtension } from '../../store/buy-flow';
import { setActiveFlow } from '../../store/system';
import SignupContainer from '../signup';

// prevent endless loop of rerendering
let TOGGLE = true;

const BuyFlow = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const {
    account: { accountId, supportedConnector },
    data: {
      connectors: { data: connectors },
    },
  } = useSelector(selectState);

  const [connectorId, setConnectorId] = useState<string | null>();
  const [trialExpired, setTrialExpired] = useState<string | null>();
  const [showDirectBuy, setShowDirectBuy] = useState(false);

  useEffect(() => {
    dispatch(blockPageFromIndexing());
    if (!checkIsAuthenticated()) {
      dispatch(setActiveFlow('avatax-direct-buy'));
      setShowDirectBuy(true);
    } else {
      setShowDirectBuy(false);
      dispatch(setActiveFlow('avatax-buy'));
    }
  }, []);

  useEffect(() => {
    if (accountId == null) return;
    dispatch(setActiveFlow('avatax-buy'));
    dispatch(getConnectors());
    dispatch(getMarketingDataFromUrl());
  }, [accountId]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setConnectorId(searchParams.get('connectorId') || sessionStorage.get('connectorId') || null);
    setTrialExpired(searchParams.get('trialExpired'));
  }, [location.search]);

  useEffect(() => {
    if (trialExpired) dispatch(setTrialExtension());
  }, [trialExpired]);

  useEffect(() => {
    if (!connectorId || !connectors.length) return;
    dispatch(selectConnector(connectorId));
    sessionStorage.set('connectorId', connectorId);
  }, [connectorId, connectors]);

  if (accountId === null || showDirectBuy) return <SignupContainer />;

  if (!supportedConnector && TOGGLE) {
    TOGGLE = false;
    dispatch(getSystemErrorMessaging({ errorCode: 'unsupportedConnector' }));
  }

  return (
    <Switch>
      <Route exact path='/buy' component={TierSelector} />
      <Route path='/buy/payment'>
        <CybersourcePaymentPage paymentView='default' />
      </Route>
      <Route path='/buy/success' component={ThankYou} />
      <Route component={PageNotFound} />
    </Switch>
  );
};

export default withRouter(BuyFlow);
